import CreditBased from "./CreditBased";

export default CreditBased;
